import { gql } from '../../../../../hooks'

export const READ_LABORATORIES = gql`
  query AdministrationReadReportLaboratories($id: ID!) {
    aRead(path: "other/laboratories", id: $id) {
    }
  }
`
